module.exports = __webpack_public_path__ + "static/img/3-active.41086877.png";